import type { ExtraMember, ProjectStatus } from '../../api/create-project'

export interface WizardState {
  // step 1 - identity
  name: string
  code: string
  icon: string
  color: string
  // step 2 - metadata
  description: string
  department: string
  principal_investigator: string
  institution: string
  irb_reference: string
  // step 3 - schedule + locale
  start_date: string
  end_date: string
  time_zone: string
  default_language: string
  default_calendar: 'jalali' | 'gregorian'
  data_retention_policy: string
  status: ProjectStatus
  // step 4 - members
  initial_admin_id: string
  extra_members: ExtraMember[]
}

export const INITIAL_STATE: WizardState = {
  name: '',
  code: '',
  icon: '',
  color: '#274690',
  description: '',
  department: '',
  principal_investigator: '',
  institution: '',
  irb_reference: '',
  start_date: '',
  end_date: '',
  time_zone: 'Asia/Tehran',
  default_language: 'fa',
  default_calendar: 'jalali',
  data_retention_policy: '',
  status: 'active',
  initial_admin_id: '',
  extra_members: [],
}

export const STEPS = [
  { id: 1, label: 'هویت' },
  { id: 2, label: 'توضیحات' },
  { id: 3, label: 'زمان‌بندی' },
  { id: 4, label: 'اعضا' },
  { id: 5, label: 'مرور' },
] as const

export type StepId = (typeof STEPS)[number]['id']
